import { FormAutocomplete, FormAutoCompleteProps, FormSelectOption, TranslationFuncType } from "@itk/mui-components";
import { OmitSafe } from "@itk/typescript-utils";
import { useMemo } from "react";

import { Stack } from "@mui/material";
import { getContactPersonPermissions, usePermissionsTranslation } from "../../translations-enums-hooks/usePermissionTranslation";
import { Shared_ContactPersonPermissionKinds } from "src/backend/openapi/v1";

export const FormContactPersonPermissionKindAutocomplete = <TObject extends TranslationFuncType, TObjectKey extends keyof TObject>(
  props: OmitSafe<FormAutoCompleteProps<FormSelectOption<Shared_ContactPersonPermissionKinds>, Shared_ContactPersonPermissionKinds, TObject, TObjectKey>, "options" | "getId" | "getOptionLabel"> & {
    labelName?: string;
    placeHolderValue?: string;
  }
) => {
  const { formFieldState, formFieldController, ...rest } = props;

  const { getPermissionTranslation } = usePermissionsTranslation();

  const options = useMemo((): FormSelectOption<Shared_ContactPersonPermissionKinds>[] => {
    return Object.entries(getContactPersonPermissions())
      .map(entry => ({ value: entry[1] as Shared_ContactPersonPermissionKinds, description: getPermissionTranslation(entry[1] as Shared_ContactPersonPermissionKinds) }))
      .sort((x, y) => x.description.localeCompare(y.description));
  }, [getPermissionTranslation]);

  return (
    <Stack direction="column" width="100%">
      <FormAutocomplete
        disableClearable
        formFieldState={formFieldState}
        formFieldController={formFieldController}
        options={options}
        getId={option => option.value}
        getOptionLabel={option => option.description}
        {...rest}
      />
    </Stack>
  );
};
